package com.eladfinish.bible.contest.screens.settings.ui.screens

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.OPEN_QUESTIONS_NUMBER_PER_PAGE
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.OPEN_QUESTIONS_SHUFFLE_SWITCH
import com.eladfinish.bible.contest.open_questions_shuffle_title
import com.eladfinish.bible.contest.pref_description_open_questions_number_per_page
import com.eladfinish.bible.contest.screens.settings.ui.preferences.DropdownPreference
import com.eladfinish.bible.contest.screens.settings.ui.preferences.PreferenceSwitch
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun OpenQuestionsSettingsScreen(
    settings: KeyValueSettings,
) {
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.open_questions_shuffle_title),
        key = OPEN_QUESTIONS_SHUFFLE_SWITCH,
        defaultValue = true,
        summaryOn = "השאלות תופענה בסדר אקראי",
        summaryOff = "השאלות תופענה בסדר קבוע",
        settings = settings,
    )
    Divider()
    DropdownPreference(
        title = stringResource(SharedRes.strings.pref_description_open_questions_number_per_page),
        key = OPEN_QUESTIONS_NUMBER_PER_PAGE,
        entries = listOf(10, 25, 50, 100).map { it.toString() }.toImmutableList(),
        entryValues = listOf(10, 25, 50, 100).map { it.toString() }.toImmutableList(),
        settings = settings,
    )
}
